import React, { ReactElement } from 'react';
import MessageBar from '../MessageBar/MessageBar';
import './ScreenContainer.css';

interface Props {
  logoURL?: string;
  title?: string;
  subTitle?: string;
  errorKey?: string;
  isLineAnimating?: boolean;
  topActionComponent?: ReactElement;
  bottomActionComponent: ReactElement;
}

const ScreenContainer: React.FC<Props> = ({
  logoURL,
  title,
  isLineAnimating = false,
  topActionComponent,
  bottomActionComponent,
  subTitle,
  errorKey,
  children,
}) => (
  <div>
    <div className="user-sign-container">
      <div className={`loading-line ${isLineAnimating ? 'loading' : ''}`}></div>
      {topActionComponent && <span className="top-action-container">{topActionComponent}</span>}
      {logoURL && (
        <img
          className={`logo ${topActionComponent ? 'top-action-margin' : ''}`}
          src={logoURL}
          alt="logo"
        ></img>
      )}
      {title && <span className="title">{title}</span>}
      {subTitle && <span className="sub-title">{subTitle}</span>}
      {title &&
        (errorKey ? (
          <MessageBar messageKey={errorKey}></MessageBar>
        ) : (
          <hr className={`divider ${subTitle ? 'sub-title-margin' : ''}`}></hr>
        ))}
      {children}
      <span className="bottom-action-container">{bottomActionComponent}</span>
    </div>
  </div>
);

export default ScreenContainer;
